import {Component, Renderer2} from '@angular/core';
import * as _ from 'lodash';
import {Table} from '../../classes/common/table/table';
import Formatting from '../../utils/formatting';

@Component({
  selector: 'arm-table',
  templateUrl: './arm-table.component.html',
  styleUrls: ['./arm-table.component.scss']
})
export class ArmTableComponent extends Table {

  getCellValue(row, name: string, path): string {
    return _.isNil(path) ? row[name] : _.get(row, path, '');
  }

  getCellTemplate(row, name: string, path, transformer: any): string {
    const value = this.getCellValue(row, name, path);

    if (transformer){
      return new transformer().transform(value, row);
    }

    return Formatting.value(value);
  }
}
